import { useEffect, useState } from 'react';
import './index.scss';
import { Form, Input, Toast, Radio, Space, CascadePicker } from 'antd-mobile';
import CustomScroll from '@src/component/customScroll';
import BottomIcon from '@src/component/bottomIcon';
import DealerDoorAreaSelector from '@src/component/DealerDoorAreaSelector';
import {
  getResult,
  getCFDealerDoor,
  updateQualification,
} from '@service/applyFormSubService';
import { getBaseAreaData } from '@service/commonService';
import PickFengzhuang from '@src/component/PickFengzhuang';
import store from '@src/util/store';
import { gotor, goto } from '@src/route';
import { getConfigByKey } from '@src/util';
import { hasLoanAndQuaStatus } from '@src/service/ownService';
export default function Index() {
  const [form] = Form.useForm();
  const [isNewAdd, setIsNewAdd] = useState<boolean>(true);
  const [checked, setChecked] = useState<boolean>(false);
  // 储存的form
  const [formData, setFormData] = useState<any>({});
  const [educationList, setEducationList] = useState([]);
  // 城市
  const [visibleprov, setVisibleprov] = useState<boolean>(false);
  const [provList, setProvList] = useState([]); //城市列表
  // 选中的经销商
  const [dealerInfo, setDealerInfo] = useState<any>();
  const [visibleDealer, setVisibleDealer] = useState<boolean>(false);
  // 所有经销商
  const [dealerListAll, setDealerListAll] = useState([]);
  // 判断是否是经销商邀请码
  const [inviteCode, setInviteCode] = useState<boolean>(false);
  // 设置title
  useEffect(() => {
    document.title = '填写预审信息';
  }, []);
  useEffect(() => {
    getCity();
    (async () => {
      try {
        Toast.show({
          icon: 'loading',
          content: '加载中…',
          duration: 0,
          maskClickable: false,
        });
        const { code } = (await hasLoanAndQuaStatus()) || {};
        Toast.clear();
        if (code === 999) {
          Toast.show({
            content: '您已有业务办理成功，暂不支持新的业务办理',
            duration: 1000,
            afterClose: () => {
              gotor('/rzIndex');
            },
          });
        }
        // 当前无业务
        else if ([0, 1, 2, 4, 9].includes(code)) {
          gotor('/rzStatus');
        }
      } catch (err: any) {
        Toast.show({
          content: err?.errmsg || '状态查询失败',
          duration: 1000,
          afterClose: () => {
            gotor('/rzIndex');
          },
        });
      }
      try {
        // 设置购车地
        await getDealerAll();
      } catch (error) {
        console.log(error);
      }
      initFinct();
    })();
  }, []);

  // 获取有门店的城市
  const getCity = () => {
    (async () => {
      const regioninit: any = await getBaseAreaData();
      const region: any = [];
      regioninit.forEach(
        (item: {
          id: number;
          value: string;
          cfExperiment: number;
          children: any[];
        }) => {
          const ca: any[] = [];
          item.children.forEach(
            (subitem: { cfExperiment: number; id: number; value: string }) => {
              ca.push({
                value: `${subitem.id || ''}:${subitem.value || ''}`,
                label: subitem.value,
                cfExperiment: subitem.cfExperiment,
              });
            }
          );
          region.push({
            value: `${item.id || ''}:${item.value || ''}`,
            label: item.value,
            cfExperiment: item.cfExperiment,
            children: ca,
          });
        }
      );
      setProvList(region);
    })();
  };
  // 初始化
  const initFinct = () => {
    if (getConfigByKey('xl')?.length) {
      setEducationList(getConfigByKey('xl'));
    } else {
      setTimeout(() => {
        if (getConfigByKey('xl')?.length) {
          setEducationList(getConfigByKey('xl'));
        }
      }, 3000);
    }
    // 回填缓存数据
    if (store.get('setInviteCode')) {
      setInviteCode(store.get('setInviteCode'));
    }
    if (store.get('instalmentsFrom')) {
      form.setFieldsValue(store.get('instalmentsFrom'));
      setFormData(form.getFieldsValue(true));
    }
    if (store.get('isNewAdd')) {
      setIsNewAdd(store.get('isNewAdd'));
    }
    if (store.get('instalmentsFrom')) {
      return;
    }
    // 获取提交数据
    getResult()
      .then((res) => {
        if (res) {
          // 判断是否是有经销商来判断是新增还是修改
          if (res.dealerId) {
            setIsNewAdd(false);
            if (store.get('qualification')) {
              setData(store.get('qualification'));
            }
          }
          setData(res, true);
        } else {
          if (store.get('qualification')) {
            setData(store.get('qualification'));
          }
        }
      })
      .catch((err) => {
        err?.errmsg && Toast.show(err?.errmsg);
      });
  };

  // 回填数据
  // const setData = (res: any, type?: boolean) => {
  //   // 处理学历pack及历史数据
  //   let key = "value";
  //   if (isNaN(res.education)) {
  //     key = "label";
  //   }
  //   const de: any = getConfigByKey("xl")?.find(
  //     (ret: any) => ret[key] == res.education
  //   );
  //   const formData: any = {
  //     education: de?.value,
  //     isWork: res.isWork,
  //     company: res.company,
  //     isSecurity: res.isSecurity,
  //     isMortgage: res.isMortgage,
  //   };
  //   // 如果是编辑才回显经销商
  //   if (type) {
  //     let provinceName = "";
  //     // 处理地区pack
  //     if (res.cityCode && res.provinceCode) {
  //       provinceName = `${res.province as string}/${res.city as string}`;
  //     }
  //     formData.provinceName = provinceName;
  //     formData.inviteCode = res.inviteCode;
  //     formData.dealerId = res.dealerId;
  //     formData.provinceCode = res.provinceCode;
  //     formData.cityCode = res.cityCode;
  //     formData.city = res.city;
  //     formData.province = res.province;
  //   }
  //   form.setFieldsValue(formData);
  //   setFormData(form.getFieldsValue(true));
  // };

  // 提交
  const subClick = () => {
    if (!checked) {
      Toast.show('请阅读相关协议');
      return;
    }
    form.validateFields().then((res) => {
      res.isNewAdd = isNewAdd;
      res.purpose = '购买新车';
      Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
        maskClickable: false,
      });
      if (res.isCreditCard == 0) {
        delete res.creditLimitType;
      }
      updateQualification(res)
        .then(() => {
          store.remove('inviteCode');
          store.remove('instalmentsFrom');
          store.remove('isNewAdd');
          Toast.clear();
          gotor('/rzStatus');
        })
        .catch((err) => {
          Toast.show(err?.errmsg || '资格预审保存失败！');
        });
    });
  };

  // 回填数据
  const setData = (res: any, type?: boolean) => {
    // 处理学历pack及历史数据
    let key = 'value';
    if (isNaN(res.education)) {
      key = 'label';
    }
    const de: any = getConfigByKey('xl')?.find(
      (ret: any) => ret[key] == res.education
    );
    const formData: any = {
      education: de?.value,
      isWork: res.isWork,
      company: res.company,
      isSecurity: res.isSecurity,
      isMortgage: res.isMortgage,
    };
    // 如果是编辑才回显经销商
    if (type) {
      let provinceName = '';
      // 处理地区pack
      if (res.cityCode && res.provinceCode) {
        provinceName = `${res.province as string}/${res.city as string}`;
      }
      formData.provinceName = provinceName;
      formData.inviteCode = res.inviteCode;
      formData.dealerId = res.dealerId;
      formData.provinceCode = res.provinceCode;
      formData.cityCode = res.cityCode;
      formData.city = res.city;
      formData.province = res.province;
    }
    if (res.dealerId) {
      getDealerAll().then((list: any) => {
        const item = list.find((d: any) => d.id == res.dealerId);
        setDealerInfo(item);
      });
    }
    form.setFieldsValue(formData);
    setFormData(form.getFieldsValue(true));
  };

  // 获取所有经销商
  const getDealerAll = (): any => {
    return new Promise((resolve, rejects) => {
      if (dealerListAll.length) {
        resolve(dealerListAll);
      } else {
        Toast.show({
          icon: 'loading',
          content: '加载中…',
          duration: 0,
          maskClickable: false,
        });
        getCFDealerDoor()
          .then((res) => {
            Toast.clear();
            const list = (res || []).map((res: any) => {
              res.label = res.storeName;
              res.value = res.id;
              return res;
            });
            resolve(list);
            setDealerListAll(list);
          })
          .catch((err) => {
            rejects();
            Toast.show(err?.errmsg || '经销商数据获取失败！');
          });
      }
    });
  };

  // 设置经销商
  const setDealer = (item: any) => {
    form.setFieldsValue({
      dealerId: item.id,
      provinceName: `${item.provinceName as string}${item.cityName as string}`,
      provinceCode: item.provinceCode,
      cityCode: item.cityCode,
      province: item.provinceName,
      city: item.cityName,
    });
    setDealerInfo(item);
  };

  // 根据经销商邀请码获取
  const inviteCodeChange = (e: any) => {
    if (e.length === 4) {
      getDealerAll()
        .then((list: any) => {
          const item = list.find(
            (d: any) =>
              d.inviteCode &&
              d.inviteCode.toLocaleLowerCase() == e.toLocaleLowerCase()
          );
          if (item) {
            setInviteCode(true);
            setDealer(item);
          } else {
            form.setFieldsValue({
              inviteCode: '',
            });
            setInviteCode(false);
            Toast.show('该邀请码不存在');
          }
        })
        .catch(() => {
          form.setFieldsValue({
            inviteCode: '',
          });
          setInviteCode(false);
        });
    } else {
      setInviteCode(false);
    }
  };
  // 保持数据
  const saveCache = () => {
    store.set('inviteCode', inviteCode);
    store.set('instalmentsFrom', form.getFieldsValue(true));
    store.set('isNewAdd', isNewAdd);
  };
  return (
    <div className="page bottomFit instalments">
      <CustomScroll>
        <div className="top-box">
          <div className="float-box">
            <div className="tips">
              <span>*</span>请如实完整填写以下资料，否则会影响您的评估结果
            </div>
            <div className="inputForm">
              <Form
                form={form}
                layout="horizontal"
                onValuesChange={() => {
                  setFormData(form.getFieldsValue(true));
                }}
              >
                <div className="more-xia">
                  <Form.Item
                    name="education"
                    clickable={false}
                    label="学&nbsp;&nbsp;&nbsp;历："
                    rules={[{ required: true, message: '请选择学历' }]}
                  >
                    <PickFengzhuang
                      placeholder="请选择您的学历"
                      columns={educationList}
                    />
                  </Form.Item>
                </div>
                <div className="adm-list-item-content-prefix-144">
                  <Form.Item
                    name="isWork"
                    label="是否有稳定工作："
                    rules={[
                      { required: true, message: '请选择是否有稳定工作' },
                    ]}
                  >
                    <Radio.Group>
                      <Space direction="horizontal" style={{ '--gap': '63px' }}>
                        <Radio
                          value={1}
                          icon={(checked) =>
                            checked ? (
                              <div className="checked" />
                            ) : (
                              <div className="no-checked" />
                            )
                          }
                        >
                          是
                        </Radio>
                        <Radio
                          value={0}
                          icon={(checked) =>
                            checked ? (
                              <div className="checked" />
                            ) : (
                              <div className="no-checked" />
                            )
                          }
                        >
                          否
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <div className="conceal-inputting">
                  <Form.Item name="provinceCode">
                    <Input />
                  </Form.Item>
                  <Form.Item name="cityCode">
                    <Input />
                  </Form.Item>
                  <Form.Item name="city">
                    <Input />
                  </Form.Item>
                  <Form.Item name="province">
                    <Input />
                  </Form.Item>
                </div>
                {formData.isWork == 1 && (
                  <div className="ts">
                    <Form.Item
                      name="company"
                      label="工作单位名称："
                      rules={[
                        { required: true, message: '请输入工作单位名称' },
                      ]}
                    >
                      <Input
                        placeholder="请输入工作单位名称"
                        maxLength={40}
                        onChange={() => {
                          console.log(form.getFieldError(['company']));
                        }}
                      />
                    </Form.Item>
                    <div className="tips2">
                      请参照营业执照或者实际单位名字填写，否则会影响审批结果
                    </div>
                  </div>
                )}
                <div className="adm-list-item-content-prefix-144">
                  <Form.Item
                    name="isSecurity"
                    label="是否有公积金或社保："
                    rules={[
                      { required: true, message: '请选择是否有公积金或社保' },
                    ]}
                  >
                    <Radio.Group>
                      <Space direction="horizontal" style={{ '--gap': '63px' }}>
                        <Radio
                          value={1}
                          icon={(checked) =>
                            checked ? (
                              <div className="checked" />
                            ) : (
                              <div className="no-checked" />
                            )
                          }
                        >
                          有
                        </Radio>
                        <Radio
                          value={0}
                          icon={(checked) =>
                            checked ? (
                              <div className="checked" />
                            ) : (
                              <div className="no-checked" />
                            )
                          }
                        >
                          无
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <div className="adm-list-item-content-prefix-144">
                  <Form.Item
                    name="isMortgage"
                    label="是否有房贷："
                    rules={[{ required: true, message: '请选择是否有房贷' }]}
                  >
                    <Radio.Group>
                      <Space direction="horizontal" style={{ '--gap': '63px' }}>
                        <Radio
                          value={1}
                          icon={(checked) =>
                            checked ? (
                              <div className="checked" />
                            ) : (
                              <div className="no-checked" />
                            )
                          }
                        >
                          有
                        </Radio>
                        <Radio
                          value={0}
                          icon={(checked) =>
                            checked ? (
                              <div className="checked" />
                            ) : (
                              <div className="no-checked" />
                            )
                          }
                        >
                          无
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <div className="adm-list-item-content-prefix-144">
                  <Form.Item
                    name="isCreditCard"
                    label="是否有信用卡："
                    rules={[{ required: true, message: '请选择是否有信用卡' }]}
                  >
                    <Radio.Group>
                      <Space direction="horizontal" style={{ '--gap': '63px' }}>
                        <Radio
                          value={1}
                          icon={(checked) =>
                            checked ? (
                              <div className="checked" />
                            ) : (
                              <div className="no-checked" />
                            )
                          }
                        >
                          有
                        </Radio>
                        <Radio
                          value={0}
                          icon={(checked) =>
                            checked ? (
                              <div className="checked" />
                            ) : (
                              <div className="no-checked" />
                            )
                          }
                        >
                          无
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </div>
                {formData.isCreditCard ? (
                  <>
                    <div
                      className="adm-list-item-content-prefix-144"
                      style={{ height: '30px' }}
                    >
                      <Form.Item label="请选择您的可用额度：">&nbsp;</Form.Item>
                    </div>
                    <div className="adm-list-item-content-prefix-144">
                      <Form.Item
                        rules={[
                          { required: true, message: '请选择您的可用额度' },
                        ]}
                        name="creditLimitType"
                        className="break-line"
                      >
                        <Radio.Group>
                          <Space
                            direction="horizontal"
                            style={{
                              width: '100%',
                            }}
                          >
                            <Radio
                              value={1}
                              icon={(checked) =>
                                checked ? (
                                  <div className="checked" />
                                ) : (
                                  <div className="no-checked" />
                                )
                              }
                            >
                              5000以下
                            </Radio>
                            <Radio
                              value={2}
                              icon={(checked) =>
                                checked ? (
                                  <div className="checked" />
                                ) : (
                                  <div className="no-checked" />
                                )
                              }
                            >
                              5000~10000
                            </Radio>
                          </Space>
                          <Space
                            direction="horizontal"
                            style={{
                              width: '100%',
                            }}
                          >
                            <Radio
                              value={3}
                              icon={(checked) =>
                                checked ? (
                                  <div className="checked" />
                                ) : (
                                  <div className="no-checked" />
                                )
                              }
                            >
                              10000~20000
                            </Radio>
                            <Radio
                              value={4}
                              icon={(checked) =>
                                checked ? (
                                  <div className="checked" />
                                ) : (
                                  <div className="no-checked" />
                                )
                              }
                            >
                              20000以上
                            </Radio>
                          </Space>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  </>
                ) : null}

                <div className="more-xia">
                  <Form.Item
                    name="provinceName"
                    label="购车地："
                    clickable={false}
                    arrow={false}
                    onClick={() => {
                      setVisibleprov(true);
                    }}
                    rules={[{ required: true, message: '请选择购车地' }]}
                  >
                    <Input placeholder="请选择购车地" readOnly />
                  </Form.Item>
                </div>
                <Form.Item name="inviteCode" label="经销商邀请码：">
                  <Input
                    placeholder="非必填"
                    onChange={inviteCodeChange}
                    maxLength={4}
                  />
                </Form.Item>
                <div className={inviteCode ? '' : 'more-xia'}>
                  <Form.Item
                    name="dealerId"
                    label="意向提车门店："
                    arrow={false}
                    onClick={() => {
                      inviteCode ? null : setVisibleDealer(true);
                    }}
                    clickable={false}
                    rules={[{ required: true, message: '请选择意向提车门店' }]}
                  >
                    <PickFengzhuang
                      placeholder="请选择意向提车门店"
                      disabled
                      columns={dealerListAll}
                    />
                  </Form.Item>
                </div>
                {dealerInfo?.id && (
                  <div className="tips2">
                    此处选择门店仅作参考，分期办理中可修改购车门店
                    <br />
                    所选门店地址：{dealerInfo?.address}
                    <br />
                    所选门店电话：{dealerInfo?.tel}
                  </div>
                )}
              </Form>
            </div>
          </div>
          <footer>
            <div
              className="checkedbox"
              onClick={() => {
                setChecked(!checked);
              }}
            >
              <div>
                {checked ? (
                  <div className="checked" />
                ) : (
                  <div className="no-checked" />
                )}
                <div className="checkedtype">
                  我已阅读并同意
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      saveCache();
                      goto('/agreement/auth');
                    }}
                  >
                    《信息查询授权书》
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      saveCache();
                      goto('/agreement/pa');
                    }}
                  >
                    《平台用户协议（含隐私协议）》
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      saveCache();
                      goto('/agreement/information');
                    }}
                  >
                    《信息技术服务合同（客户信用卡分期）》
                  </span>
                  {/* <span onClick={(e) => {
								e.stopPropagation()
								saveCache()
								goto('/agreement/cr')
							}}>《征信授权书》</span>
							<span onClick={(e) => {
								e.stopPropagation()
								saveCache()
								goto('/agreement/en')
							}}>《委托担保申请书》</span> */}
                </div>
              </div>
            </div>
            <div className="button-them submit" onClick={subClick}>
              提交
            </div>
          </footer>
          <BottomIcon />
        </div>
      </CustomScroll>
      {/* 购车地 */}
      <CascadePicker
        options={provList}
        visible={visibleprov}
        onConfirm={(e:any) => {
          const provinceA = (e[0] || '').split(':');
          const city = (e[1] || '').split(':');
          form.setFieldsValue({
            dealerId: '',
            provinceCode: provinceA[0],
            cityCode: city[0],
            province: provinceA[1],
            city: city[1],
            inviteCode: '',
            provinceName: `${provinceA[1] as string}/${city[1] as string}`,
          });
          setDealerInfo(null);
          setFormData(form.getFieldsValue(true));
        }}
        onClose={() => {
          setVisibleprov(false);
        }}
      />
      {/* 经销商 */}
      <DealerDoorAreaSelector
        province={formData.provinceCode}
        city={formData.cityCode}
        onClose={() => {
          setVisibleDealer(false);
        }}
        onConfirm={(res) => {
          setDealer(res);
          setVisibleDealer(false);
        }}
        visible={visibleDealer}
        list={dealerListAll}
      />
    </div>
  );
}
